var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4765_894",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4765_894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.83073 19.1927C3.30365 19.1927 2.85243 19.005 2.47708 18.6297C2.10174 18.2543 1.91406 17.8031 1.91406 17.276V5.77604C1.91406 5.24896 2.10174 4.79774 2.47708 4.4224C2.85243 4.04705 3.30365 3.85938 3.83073 3.85938H19.1641C19.6911 3.85938 20.1424 4.04705 20.5177 4.4224C20.8931 4.79774 21.0807 5.24896 21.0807 5.77604V17.276C21.0807 17.8031 20.8931 18.2543 20.5177 18.6297C20.1424 19.005 19.6911 19.1927 19.1641 19.1927H3.83073ZM11.4974 12.4844L19.1641 7.69271V5.77604L11.4974 10.5677L3.83073 5.77604V7.69271L11.4974 12.4844Z",
    fill: "#695BD6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail2);
export default __webpack_public_path__ + "static/media/mail2.38c0c17db75862bd5a95c1db93f3280e.svg";
export { ForwardRef as ReactComponent };